"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _calculateSize = _interopRequireDefault(require("calculate-size"));

var textWidthCalculator = function textWidthCalculator(_ref) {
  var text = _ref.text,
      fontSize = _ref.fontSize,
      _ref$fontFamily = _ref.fontFamily,
      fontFamily = _ref$fontFamily === void 0 ? "Arial" : _ref$fontFamily,
      _ref$minWidth = _ref.minWidth,
      minWidth = _ref$minWidth === void 0 ? null : _ref$minWidth,
      _ref$maxWidth = _ref.maxWidth,
      maxWidth = _ref$maxWidth === void 0 ? null : _ref$maxWidth,
      _ref$desiredWidth = _ref.desiredWidth,
      desiredWidth = _ref$desiredWidth === void 0 ? "auto" : _ref$desiredWidth,
      _ref$extraWidth = _ref.extraWidth,
      extraWidth = _ref$extraWidth === void 0 ? null : _ref$extraWidth;

  if (desiredWidth !== "auto") {
    return desiredWidth;
  }

  var calculatedLength = typeof window !== "undefined" ? (0, _calculateSize["default"])(text, {
    fontSize: fontSize + "px",
    font: fontFamily
  }).width + extraWidth : 100;

  if (minWidth && calculatedLength <= minWidth) {
    return minWidth;
  }

  if (maxWidth && calculatedLength >= maxWidth) {
    return maxWidth;
  }

  return calculatedLength;
};

var _default = textWidthCalculator;
exports["default"] = _default;